import { css, html, LitElement } from "lit";
import { customElement, state } from "lit/decorators.js";
import { renderCategoryIconColor } from "../fragments.js";

type Runner = { id: string, label: string, icon?: string };

const runners: Runner[] = [
  { id: 'playwright', label: 'Playwright' },
  { id: 'pytest',     label: 'Pytest' },
  { id: 'vitest',     label: 'Vitest' },
  { id: 'jest',       label: 'Jest' },
  { id: 'cucumberjs', label: 'CucumberJS' },
  { id: 'bun',        label: 'Bun' },
  { id: 'rust',       label: 'Rust' },
  { id: 'junit',      label: 'JUnit XML' },
  { id: 'custom',     label: 'Custom',     icon: 'puzzle' },
];

@customElement('fk-runner-picker')
export class FKRunnerPicker extends LitElement {
  @state() private _selected = 'playwright';

  override render() {
    return html`
      <v-box>
        <div class="tiles" role="tablist">
          ${runners.map(r => html`
            <button
              class="tile"
              role="tab"
              aria-selected=${this._selected === r.id ? 'true' : 'false'}
              @click=${() => this._selected = r.id}
            >
              ${r.icon
                ? html`<sl-icon class="tile-icon" name=${r.icon}></sl-icon>`
                : renderCategoryIconColor(r.id, { klass: 'tile-icon' })}
              <span class="tile-label">${r.label}</span>
            </button>
          `)}
        </div>
        <sl-divider style="--spacing: 0;"></sl-divider>
        <slot name=${this._selected}></slot>
      </v-box>
    `;
  }

  static styles = css`
    :host {
      display: block;
    }

    .tiles {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      gap: var(--sl-spacing-small);
    }

    .tile {
      display: flex;
      align-items: center;
      gap: var(--sl-spacing-small);
      padding: var(--sl-spacing-small) var(--sl-spacing-small);
      background: white;
      border: 1px solid var(--sl-color-neutral-200);
      border-radius: var(--sl-border-radius-large);
      cursor: pointer;
      font: inherit;
      color: inherit;
      text-align: left;
      transition: border-color 120ms ease, transform 120ms ease, box-shadow 120ms ease;
    }

    .tile:hover {
      border-color: var(--sl-color-primary-400);
      transform: translateY(-1px);
      box-shadow: var(--sl-shadow-small);
    }

    .tile[aria-selected="true"] {
      border-color: var(--sl-color-primary-500);
      box-shadow: 0 0 0 1px var(--sl-color-primary-500) inset;
      background: var(--sl-color-primary-50);
    }

    .tile-icon {
      flex: 0 0 auto;
    }

    .tile-label {
    }
  `;
}
